export default "__VITE_ASSET__CDDeR7qX__"